import { ApplicationTypes } from '@/models/ApplicationType';
import { ProgramNames } from '@/models/Program';
import { ApplicationStatus } from '@/utils/constants';

export function isLastStandardInList(
  sortedStandards: Array<{ standardId: number }> | null | undefined,
  standardId: number
): boolean {
  if (sortedStandards == null || sortedStandards.length === 0) return false;

  return sortedStandards[sortedStandards.length - 1].standardId === standardId;
}

export function arePreFinalStandardsComplete(
  standardError: Record<number, boolean> | null | undefined
): boolean {
  const values = Object.values(standardError ?? {});

  // TODO(bug): `standardError` is keyed by standardId, so Object.values() yields entries in ascending
  // numeric-id order and pop() drops the standard with the *highest id* — not the last standard in
  // display order (CurrentApplicationContext sorts by sortOrder first). It also drops a real
  // pre-final standard when the final standard has no entry (computeStandardError omits standards
  // with no needed questions while In Progress/In Revision). Expected: exclude the final standard by
  // its standardId (e.g. pass the last sortedStandards id in) rather than by object position.
  // Remove final standard to preserve existing behavior around completion checks.
  values.pop();

  return values.every((value) => value === true);
}

export function shouldBlockLastStandardNavigation({
  isTargetingLastStandard,
  applicationTypeId,
  programId,
  status,
  standardError,
  canEdit,
}: {
  isTargetingLastStandard: boolean;
  applicationTypeId: ApplicationTypes | null | undefined;
  programId: ProgramNames;
  status: ApplicationStatus | null | undefined;
  standardError: Record<number, boolean> | null | undefined;
  canEdit: boolean;
}): boolean {
  const lockDownLastStandardUntilComplete =
    applicationTypeId == ApplicationTypes.Standard &&
    [ProgramNames.TreeCityUSA, ProgramNames.TreeCitiesWorld].includes(programId);

  if (!lockDownLastStandardUntilComplete) return false;

  const beyondInProgress = status != null && status > ApplicationStatus.InProgress;

  if (!isTargetingLastStandard || beyondInProgress) return false;

  const isAllAnswered = arePreFinalStandardsComplete(standardError);

  return beyondInProgress || !isAllAnswered || !canEdit;
}
